export const fieldsInfo: any = {
  readonlyFields: [
    'partNumber',
    'brandLabel',
    'partTypeCategory',
    'partTypeSubCategory',
    'coreGroup',
    'coreReturnDaysToExpiry',
    'warrantyDistanceUom',
    'warrantyTimeUom',
  ],
  // Date input fields
  dateFields: [
    'effectiveDate',
    'availableDate'
  ],
  // Fields With 'Add another' possibility
  loopingFields: [],
  // Fields for Core Information
  coreInfoFields: [
    'coreId',
    'coreGroup',
    'corePartNumber',
    'coreReturnDaysToExpiry',
    'returnCode',
    'corePartNumber',
  ],
  // Fields for Warranty
  warrantyFields: [
    'warrantyDistance',
    'warrantyDistanceUom',
    'warrantySpecial',
    'warrantySpecialUom',
    'warrantyTime',
    'warrantyTimeUom',
  ],
  // Fields for Part History
  partHistoryFields: [
    'refurbishedPart',
    'remanufacturedPart',
    'oemPartNumber',
    'oemBrand',
    'originalSupplierPartNumber',
    'originalSupplierName',
    'oldPartNumber',
    'partNumberSupersededTo',
  ],
  // fields with full cell size
  fullSizeFields: [
    'partNumber',
    'brandLabel',
    'hasFitments',
    'nationalPopularityCode',
    'lifeCycleStatus',
    'containerType',
    'qualifier',
    'subBrand',
    'category',
    'emissionCode',
    'basePartNumber',
  ],
  // fields with quartered cell size
  quarteredSizeFields: [
    'coreClass',
    'coreGroup',
  ],

  oneSixthSizeFields: [
    'partType',
  ],

  oneThirdSizeFields: [
    'partTypeName',
  ],

  selectFields: [
    'gtinQualifier',
    'hasFitments',
    'nationalPopularityCode',
    'lifeCycleStatus',
    'minimumOrderQuantityUom',
    'itemQuantityUom',
    'quantityPerApplicationUom',
    'quantityPerApplicationQualifier',
    'hazardousMaterialCode',
    'taxable',
    'subBrand',
    'emissionCode',
    'productGroupId',
    'productSubGroupId',
    'coreId',
    'warrantySpecialUom',
    'refurbishedPart',
    'remanufacturedPart',
    'containerType',
  ],

  typeaheadFields: [],

  customFields: [
    'partType',
    'partTypeName',
  ],

  hiddenFields: [
    'partCategory',
    'partSubcategory',
  ],

};
